export default {
	isMobile(state) {
		return state.viewportSize === 'mobile';
	},
	isDesktop(state) {
		return state.viewportSize === 'desktop';
	},
};
